import PropTypes from 'prop-types';
import YouTube from './externalyoutube';

const FreeLessonFrame = ({
  videoId
  // ytOneSecWatched,
  // ytTenSecWatched,
  // ytWatchEvent,
  // ytVideoEnd,
  // ytUpdateLastSendTime
}) => {
  const onReady = () => {
    // ytVideoReady('youtube');
  };

  const onEnd = () => {
    // ytVideoEnd("youtube", this.watchEvent);
  };

  const onStateChange = () => {};
  const opts = {
    height: '100%',
    width: '100%',
    playerVars: {
      autoplay: 0,
      showinfo: 0,
      rel: 0
    }
  };
  return (
    <div>
      <YouTube
        videoId={videoId}
        onReady={onReady}
        opts={opts}
        onEnd={onEnd}
        onStateChange={onStateChange}
      />
    </div>
  );
};

export default FreeLessonFrame;

FreeLessonFrame.propTypes = {
  videoId: PropTypes.string.isRequired
  // ytVideoReady: PropTypes.func.isRequired,
  // ytOneSecWatched: PropTypes.func.isRequired,
  // ytTenSecWatched: PropTypes.func.isRequired,
  // ytWatchEvent: PropTypes.func.isRequired,
  // ytVideoEnd: PropTypes.func.isRequired,
  // ytUpdateLastSendTime: PropTypes.func.isRequired
};
